export default __webpack_public_path__ + "static/media/C4.1bdb0767.mp3";